// extracted by mini-css-extract-plugin
export var work = "post-link-module--work--3VAO4";
export var cardSizing = "post-link-module--cardSizing--_ORya";
export var clickable = "post-link-module--clickable--VxzG8";
export var previewSubtitle = "post-link-module--previewSubtitle--3ahxO";
export var readMore = "post-link-module--readMore--1IuPa";